import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AttendanceService } from '../../../../_services/attendance/attendance.service'
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ApprovalService } from "src/app/_services/approval/approval.service"; 
import { param } from 'jquery';
@Component({
  selector: 'app-attendance-approval',
  templateUrl: './attendance-approval.component.html',
  styleUrls: ['./attendance-approval.component.scss']
})
export class AttendanceApprovalComponent implements OnInit {
  jsonData: any;
  tenantId: string;
  userId: number;
  currentUser: any;
  defaultColDef:any;
   rowSelection:any
   dataSource: any;
   public columnDefs: ColDef[]; 
   sampleGridFrameworkComponents: any;
   selectedCheckboxData = [];
   private api: GridApi;  
  private columnApi: ColumnApi;  
  rowData: any;
  form: FormGroup;
  getUserName: any;
  isAdmin : boolean;
  isTenantCustomised : boolean;
  isStatus : any;

  constructor(
    private formBuilder: FormBuilder,
    private storageService: LocalStorageService,
    private attendanceService :AttendanceService,
    private allocationService: AllocationService,
    private router: Router,
    private approvalService: ApprovalService,
  ) { 
    {
      this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
      };
      this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();  

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };
  }
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.getManualapprovals();
    
  }

  async getAttendance(){
    let employeeId = this.currentUser.id;
    this.attendanceService.getAttendanceById(employeeId).subscribe((response: any) => {
      if(response.result && response.result.length > 0) {
        this.rowData = response.result.map(x => ({...x , day:this.getDays(x.attendanceDate)}));
      } else {
        this.rowData = [];
      }
    });
  }

  getManualapprovals() {
    let filterType = 'compoffapproval';
    this.approvalService.getApprovals(filterType).subscribe((response: any) => {
        this.rowData = response.manualLeaves;
        if(response.manualLeaves && response.manualLeaves.length > 0) {
          this.rowData = response.manualLeaves.map(x => ({...x , day:this.getDays(x.leaveDate)}));
        } else {
          this.rowData = [];
        }
      });

  }
   /**
   * get day from date
   * @param date 
   */
   getDays(date) {
    const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
   return weekday[new Date(date).getDay()];
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = [];
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data);
    }
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params: any) {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  private createColumnDefs() {
    return [
      {
        headerName: "Date",
        field: "leaveDate",
        filter: true,
        editable: false,
        sortable: true,
        
      },
      {
        headerName: 'Days',
        field: 'day',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Emp Id',
        field: 'localId','width': 50,
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Employee',
        field: 'employeeName',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'In',
        field: 'inTime',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Out',
        field: 'outTime',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Working Hours',
        field: 'workTimeInHours',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Comments',
        field: 'comments',
        tooltipField: 'comments',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Action',
        
        cellRenderer : (params) => {         
          const spanElement = document.createElement('div');
          spanElement.classList.add('d-flex');
          spanElement.innerHTML = `<button type="button" id="approvalBtn" class="btn btn-success" style="margin-right: 5px">Approve</button> <button type="button" id="cancelBtn" class="btn btn-danger">Cancel</button>`;
          spanElement.addEventListener('click', ($event) => {
          
            if($event.target && $event.target['id'] == "approvalBtn") {
              this.userId = params.data.id;
              $event.preventDefault();
              let element: HTMLElement = document.getElementById('confimationBtn');
              element.click();
            } else {
              $event.preventDefault();
            }
            if($event.target && $event.target['id'] == "cancelBtn") {
              this.userId = params.data.id;
              $event.preventDefault();
              let element: HTMLElement = document.getElementById('cancelConfirmationBtn');
              element.click();
            } else {
              $event.preventDefault();
            }
          });
          return spanElement;
      }
        
      },
     
    ]
  }

  /**
   * approval leave
   * @param userId 
   */
  approvalLeave(userId: number) {
    this.approvalService.manualApprovalById(userId).subscribe({
      next: (value) => {
        this.getManualapprovals();
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        
      },
    })
  }

    /**
   * cacel leave
   * @param userId 
   */
  cancelLeave(userId: number) {
    this.approvalService.manualLeaveCanelById(userId).subscribe({
      next: (value) => {
        this.getManualapprovals();
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        
      },
    })
  }

  bulkUpdateStatus(status) {
    let compOffIds = [];
    for (let item of this.selectedCheckboxData) {
      compOffIds.push(item.id);
    }
    let data = {
      status: status,
      ids: compOffIds
    }
    window.alert("This is a backgroud activity and it will take few seconds, please refresh after sometime.");
    this.approvalService.bulkStatusUpdateForLeaveApplications(data).subscribe((response: any) => {
      console.log('Status Updated!!!');
    });
  }

}
